import { createIconComponent } from '../../factory/create-icon-component';
export const ResetIcon = createIconComponent(
  'ResetIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5556 2 12 2C5.33333 2 2 7.5 2 7.5M2 7.5V4M2 7.5H5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
